// Offline snapshot persistence. One row (id: 'current') holds the whole snapshot
// so a reload — or an offline launch on the floor — serves vendor/cost/size
// lookups (the Vendors tab) with zero network.

import { getDB } from './database';
import type { SnapshotPayload, StoredSnapshot } from '../snapshot/types';

const CURRENT = 'current';

/** Cache a freshly-built snapshot, replacing any previous one. */
export async function saveSnapshot(payload: SnapshotPayload): Promise<StoredSnapshot> {
  const db = await getDB();
  const record: StoredSnapshot = { ...payload, id: CURRENT, cached_at: new Date().toISOString() };
  await db.put('snapshot', record);
  return record;
}

/** The cached snapshot, or undefined if none has been built on this device. */
export async function getSnapshot(): Promise<StoredSnapshot | undefined> {
  const db = await getDB();
  return db.get('snapshot', CURRENT);
}
